/**
 * @description 住火險保障內容類型用
*/
export enum FireItemType {
    /** FID - 下拉選單 金額 */
    FID_AMOUNT = 'AMOUNT',
    FID_MOVABLE = 'MOVABLE',
    TYPE_OPTION = 'OPTION',
    TYPE_INPUT = 'INPUT',
    TYPE_TEXT = 'TEXT',
    TYPE_SHOW = 'SHOW',
    /** 險種副約 */
    ITEM_TYPE_SUB = 'A',
    /** 險種主約 */
    ITEM_TYPE_MAIN = 'M',
    /** 是否顯示 CheckBox 提供勾選 */
    ITEM_CHECKBOX_SHOW = '1'
}
